module.exports = {
	"articleTitle1": "Best Coffee Shop: RoosRoast Coffee Works ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "RoosRoast",
	"articleLink1": "https://www.michigandaily.com/section/bside/boaa-roosroast",
	"articleLink2": "https://www.michigandaily.com/section/arts/roosroast-secondary",
	"articleSnippet1": "Mar 30, 2017 ... If you're an OG Ann Arborite (Ann Arboran?), you probably know local coffee \nshop RoosRoast as a caffeine-fanatic favorite that prides itself on ...",
	"articleSnippet2": "Sep 21, 2016 ... With closer ties to downtown and the U-M campus, RoosRoast has been the talk \nof the semester among coffee fanatics and caffeine addicts ...",
	"foodRecommendations": [],
	"articleTitle2": "RoosRoast sets up shop in Downtown Ann Arbor ",
	"address": "117 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/msk.NEW_.SAPACartShow.3.31.17.0475.jpg?itok=BmPXl-FM",
			"author": "Max Kuang",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.2798,
		"lng": -83.7477
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/roosroast.json
// module id = 962
// module chunks = 0